export const transactionTranslation = {
  en: {
    invoicesAndPayments: "Invoices and Payments",
    invoices: "Invoices",
    viewManageInvoices: "View and manage your invoices.",
    payments: "Payments",
    viewManagePayments: "View and manage your payments.",
    home: "Home",
    addInvoice: "+ Add Invoice",
    searchInvoice: "Search by invoice number...",
    editInvoice: "Edit Invoice",
    addNewInvoice: "Add New Invoice",
    updateInvoice: "Update Invoice",
    addInvoiceButton: "Add Invoice",
    deleteInvoiceConfirmation: "Are you sure you want to delete invoice",
    deleteActionWarning: "This action cannot be undone.",
    addPayment: "+ Add Payment",
    searchPayment: "Search by payment number...",
    editPayment: "Edit Payment",
    addNewPayment: "Add New Payment",
    updatePayment: "Update Payment",
    addPaymentButton: "Add Payment",
    deletePaymentConfirmation: "Are you sure you want to delete payment",
    "Invoice Number": "Invoice Number",
    "Client Name": "Client Name",
    "User Name": "User Name",
    "Issue Date": "Issue Date",
    "Total Amount": "Total Amount",
    "Total Paid Amount": "Total Paid Amount",
    "Due Date": "Due Date",
    "Payment Type": "Payment Type",
    "Download": "Download",
    "Status": "Status",
    "Actions": "Actions",
    "Select User": "Select User",
    "Select Payment": "Select Payment",
    "Select Payment Type": "Select Payment Type",
    "Upload Invoice": "Upload Invoice",
    "Drag & Drop or Click to Upload": "Drag & Drop or Click to Upload",
    "Supported formats: PDF, JPG, PNG": "Supported formats: PDF, JPG, PNG",
    "Paid": "Paid",
    "Unpaid": "Unpaid",
    "Discount Amount": "Discount Amount",
    "Discount Percentage": "Discount Percentage",

  },
  ar: {
    invoicesAndPayments: "الفواتير والمدفوعات",
    invoices: "الفواتير",
    viewManageInvoices: "عرض وإدارة الفواتير الخاصة بك.",
    payments: "المدفوعات",
    viewManagePayments: "عرض وإدارة المدفوعات الخاصة بك.",
    home: "الصفحة الرئيسية",
    addInvoice: "+ إضافة فاتورة",
    searchInvoice: "البحث عن طريق رقم الفاتورة...",
    editInvoice: "تعديل الفاتورة",
    addNewInvoice: "إضافة فاتورة جديدة",
    updateInvoice: "تحديث الفاتورة",
    addInvoiceButton: "إضافة فاتورة",
    deleteInvoiceConfirmation: "هل أنت متأكد أنك تريد حذف الفاتورة",
    deleteActionWarning: "لا يمكن التراجع عن هذا الإجراء.",
    addPayment: "+ إضافة دفعة",
    searchPayment: "البحث عن طريق رقم الدفعة...",
    editPayment: "تعديل الدفعة",
    addNewPayment: "إضافة دفعة جديدة",
    updatePayment: "تحديث الدفعة",
    addPaymentButton: "إضافة دفعة",
    deletePaymentConfirmation: "هل أنت متأكد أنك تريد حذف الدفعة",
    "Invoice Number": "رقم الفاتورة",
    "Client Name": "اسم العميل",
    "User Name": "اسم المستخدم",
    "Issue Date": "تاريخ الإصدار",
    "Total Amount": "المبلغ الإجمالي",
    "Total Paid Amount": "المبلغ الإجمالي المدفوع",
    "Due Date": "تاريخ الاستحقاق",
    "Payment Type": "نوع الدفع",
    "Download": "تحميل",
    "Status": "الحالة",
    "Actions": "الإجراءات",
    "Select User": "اختر المستخدم",
    "Select Payment": "اختر الدفع",
    "Select Payment Type": "اختر نوع الدفع",
    "Upload Invoice": "تحميل الفاتورة",
    "Drag & Drop or Click to Upload": "اسحب وأفلت أو انقر للتحميل",
    "Supported formats: PDF, JPG, PNG": "الصيغ المدعومة: PDF، JPG، PNG",
    "Paid": "مدفوع",
    "Unpaid": "غير مدفوع",
    "Discount Amount": "مبلغ الخصم",
    "Discount Percentage": "نسبة الخصم",
  },
};
